import ResidentialHero from './components/ResidentialHero';
import ResidentialServices from './components/ResidentialServices';
import ResidentialShowcase from './components/ResidentialShowcase';
import ResidentialFAQ from './components/ResidentialFAQ';
import ResidentialCTA from './components/ResidentialCTA';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://tadashiconsulting.co.za';

const residentialJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Luxury Residential Renovations Johannesburg',
    description:
      'Expert luxury residential renovations in Johannesburg. Complete home makeovers, kitchen and bathroom upgrades, structural improvements and premium interior finishes by licensed contractors.',
    provider: {
      '@type': 'HomeAndConstructionBusiness',
      name: 'Tadashi Consulting',
      url: siteUrl,
      telephone: '+27118752075',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Randburg',
        addressRegion: 'Gauteng',
        addressCountry: 'ZA',
      },
    },
    areaServed: { '@type': 'City', name: 'Johannesburg' },
    serviceType: 'Residential Renovation',
    url: `${siteUrl}/residential-renovations`,
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Residential Renovation Services',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Full Home Renovations' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Kitchen Remodelling' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Bathroom Upgrades' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Structural Improvements' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Luxury Interior Finishes' } },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Luxury Residential Renovations Johannesburg | Tadashi Consulting',
    url: `${siteUrl}/residential-renovations`,
    description:
      'Transform your home with expert residential construction and refined finishes. Luxury renovations in Johannesburg by licensed contractors.',
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: 'Residential Renovations', item: `${siteUrl}/residential-renovations` },
      ],
    },
  },
];

export default function ResidentialPage() {
  return (
    <main className="min-h-screen bg-white">
      <SeoHead
        title="Luxury Residential Renovations Johannesburg | Tadashi Consulting"
        description="Transform your home with expert residential construction and luxury finishes in Johannesburg. Tadashi Consulting offers complete home makeovers, kitchen remodelling, bathroom upgrades and structural improvements. Licensed contractors, turnkey solutions."
        keywords="residential renovations Johannesburg, luxury home renovation Randburg, kitchen remodelling Gauteng, bathroom upgrades South Africa, licensed home builders"
        canonical={`${siteUrl}/residential-renovations`}
        ogTitle="Luxury Residential Renovations Johannesburg | Tadashi Consulting"
        ogDescription="Transform your home with expert residential construction and refined luxury finishes in Johannesburg. Licensed contractors delivering turnkey renovation solutions."
        jsonLd={residentialJsonLd}
      />
      <ResidentialHero />
      <ResidentialServices />
      <ResidentialShowcase />
      <ResidentialFAQ />
      <ResidentialCTA />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
